module.exports = __webpack_public_path__ + "img/map-img-complete-blur.25b47f8b.webp";